import axios from 'axios'

const association = {}
// 删除协会
association.del = params => { return axios.post('/lawyer/ass/del', params) }
// 加载协会
association.load = params => { return axios.get('/lawyer/ass/load', {params}) }
// 保存协会
association.update = params => { return axios.post('/lawyer/ass/update', params) }
// 查询协会
association.find = params => { return axios.get('/lawyer/ass/find', {params}) }
//查询所有协会
association.list = params => {
  return axios.get('/lawyer/ass/list', {params})
}
export default association



// WEBPACK FOOTER //
// ./src/api/association.js